import { ThemeUICSSObject, spacing } from '@apia/theme';

const switchBox: ThemeUICSSObject = {
  p: spacing(4),
  display: 'flex',
  alignItems: 'center',
  gap: spacing(4),
  border: '1px solid',
  justifyContent: 'space-between',
  borderColor: 'palette.border.field',

  '& > .switchAndLabel': {
    alignItems: 'center',
    display: 'flex',
    gap: 2,

    svg: {
      minHeight: 'iconMd',
      minWidth: 'iconMd',
      flexShrink: 0,
    },
  },

  '& > label': {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(4),

    '&:last-of-type': {
      textAlign: 'right',
    },
  },

  '.switchLabelAndCloseButton': {
    display: 'flex',
    alignItems: 'center',
    gap: 2,

    '.switch': {
      mr: 0,
      ml: 2,
    },
  },
};

export default switchBox;
